<template>
  <div>
    <div class="d-flex flex-wrap flex-md-nowrap align-items-center">
      <!-- Contenedor principal de la propiedad -->
      <div class="w-md-auto">
        <div class="d-flex">
          <span class="  ">
            <span class="h2 mr-2">
              {{ itemTitulo }}
            </span>
            <span>
              <span v-if="dataPropiedad.Propiedad_en_Venta > 1 && dataPropiedad.Propiedad_en_Venta > 1" style="height: 1.5rem !important" class="mr-2 badge bg-danger">{{
                dataPropiedad.Propiedad_en_Venta == 1 ? $t('detail.saleTag') : ""
              }}</span>
              <span v-if="dataPropiedad.Propiedad_en_Alquiler > 1 && dataPropiedad.Propiedad_en_Alquiler > 1" style="height: 1.5rem !important" class="badge bg-success">
                {{ dataPropiedad.Propiedad_en_Alquiler == 1 ? $t('detail.rentTag') : "" }}</span
              >
            </span>
          </span>
        </div>

        <!-- Detalles de la propiedad -->
        <!-- <div  class="d-flex justify-content-start mt-2">
          <div v-if="dataPropiedad.Cuartos != 0" class=" pr-3 px-0 d-flex justify-content-start">
            <i class="fa-solid fa-bed mr-1 mt-1"></i>
            <p >Cuartos: {{ dataPropiedad.Cuartos }}</p>
          </div>
          <div v-if="dataPropiedad.Banos != 0" class=" pr-3 px-0 d-flex justify-content-start">
            <i class="fa-solid fa-bath mr-1 mt-1"></i>
            <p >Baños: {{ dataPropiedad.Banos }}</p>
          </div>
          <div v-if="dataPropiedad.Area_en_m2 != 0" class=" pr-3 px-0 d-flex justify-content-start">
            <i class="fa-solid fa-ruler-combined mr-1 mt-1"></i>
            <p>  {{ Math.round(dataPropiedad.Area_en_m2) }} m2</p>
          </div>
          
        </div> -->
        <div class="d-flex flex-wrap justify-content-start">
          <!-- Cuartos -->
          <div v-if="dataPropiedad.Cuartos != 0" class="info-item d-flex align-items-center">
            <i class="fa-solid fa-bed mr-1"></i>
            <p>{{ $t('detail.bedroomsCount', { count: dataPropiedad.Cuartos }) }}</p>
          </div>
          <!-- Baños -->
          <div v-if="dataPropiedad.Banos != 0" class="info-item d-flex align-items-center">
            <i class="fa-solid fa-bath mr-1"></i>
            <p>{{ $t('detail.bathroomsCount', { count: dataPropiedad.Banos }) }}</p>
          </div>
          <!-- Área en m2 -->
          <div v-if="dataPropiedad.Area_en_m2 != 0" class="info-item d-flex align-items-center">
            <i class="fa-solid fa-ruler-combined mr-1"></i>
            <p>{{ Math.round(dataPropiedad.Area_en_m2) }} m2</p>
          </div>
        </div>

        <!-- Botones de acción -->
      </div>

      <!-- Contenedor de precio y botones adicionales -->
      <div style="" class="w-div-precio w-md-auto flex-column flex-md-row align-items-md-end">
        <div style="" class="ml-auto">
          <div class="" v-if="dataPropiedad.Precio_de_Venta > 0 && dataPropiedad.Propiedad_en_Venta > 0">
            <span v-if="dataPropiedad.Precio_de_Alquiler > 0 && dataPropiedad.Precio_de_Venta > 0" class="text-primary" style="font-size: 16px"><b>{{ $t('detail.priceSale') }}</b> </span>
            <span v-if="dataPropiedad.Precio_de_Alquiler < 1 && dataPropiedad.Precio_de_Venta > 0" class="text-primary" style="font-size: 16px"><b>{{ $t('detail.priceSale') }}</b> </span
            ><br v-if="dataPropiedad.Precio_de_Alquiler < 1 && dataPropiedad.Precio_de_Venta > 0" />
            <span class="pb-0 mb-0 text-primary h2">{{ "$" + dataPropiedad.Precio_de_Venta }}</span>
          </div>
          <div class="text-primary" v-if="dataPropiedad.Precio_de_Alquiler > 0 && dataPropiedad.Propiedad_en_Alquiler > 0">
            <span v-if="dataPropiedad.Precio_de_Alquiler > 0 && dataPropiedad.Precio_de_Venta > 0" class="text-primary" style="font-size: 16px"><b>{{ $t('detail.priceRent') }}</b> </span>
            <span v-if="dataPropiedad.Precio_de_Alquiler > 0 && dataPropiedad.Precio_de_Venta < 1" class="text-primary" style="font-size: 16px"><b>{{ $t('detail.priceRent') }}</b> </span>
            <br v-if="dataPropiedad.Precio_de_Alquiler > 0 && dataPropiedad.Precio_de_Venta < 1" />
            <span class="pb-0 mb-0 text-primary h2">{{ "$" + dataPropiedad.Precio_de_Alquiler }}</span>
          </div>
          <!-- <div class=" " v-if="dataPropiedad.Precio_de_Alquiler > 0 && dataPropiedad.Precio_de_Venta > 0" >
            <span class="text-success " v-if="dataPropiedad.Precio_de_Alquiler > 0 && dataPropiedad.Precio_de_Venta > 0"  style="font-size: 16px;">Precio alquiler </span>
            <span class="pb-0 mb-0 text-success h2">{{'$' + dataPropiedad.Precio_de_Alquiler }}</span>
          </div> -->
        </div>
      </div>
    </div>
    <div class="d-flex flex-wrap flex-md-nowrap align-items-center gap-1">
      <div class="mt-2 w-md-auto">
        <button @click="modalCompartir()" class="btn-pill-sm btn-primary mt-1 mr-1"><i class="fa-solid fa-share-from-square"></i> {{ $t('detail.shareTitle') }}</button>

        <button class="btn-pill-sm btn-light-secondary mt-1 mr-1"><i class="fa fa-bookmark"></i> {{ $t('detail.saveButton') }}</button>
        <button class="btn-pill-sm btn-light-secondary mt-1 mr-1"><i class="fa-regular fa-heart"></i> {{ $t('detail.favorite') }}</button>
        <!-- <button class="btn-pill-sm btn-light-secondary mt-1 mr-1"><i class="fa-solid fa-print"></i> Imprimir</button> -->
      </div>
      <div style="" class="w-div-botones-filtro px-0">
        <button v-for="(property, index) in propertyButtons" :key="index" v-if="dataPropiedad[property.key] > 0" class="btn-pill-sm btn-light-secondary mr-2 mt-2">
          {{ property.label }}
        </button>
      </div>
      <b-modal centered id="modal-compartir" :title="$t('detail.shareModalTitle')" hide-footer class="m-3">
        <div>
          <!-- Enlace copiable -->
          <b-form-group :label="$t('detail.shareLinkLabel')">
            <div class="share-link-row">
              <b-form-input class="share-link-input" :value="ruta" readonly size="sm"></b-form-input>
              <button type="button" class="btn btn-light-secondary-opacity btn-sm share-copy-button" @click="copyToClipboard(ruta)">
                {{ $t('detail.copyButton') }}
              </button>
            </div>
          </b-form-group>

          <!-- Botones de compartir -->
          <div class="share-actions mt-3">
            <button type="button" :disabled="shareLoading" @click="shareOnWhatsApp" class="btn btn-pill btn-primary-solid btn-sm share-action-button">
              <i class="fa-brands fa-whatsapp mr-1"></i>
              {{ shareLoading ? $t('detail.preparing') : $t('detail.whatsappLabel') }}
            </button>
            <button type="button" :disabled="shareLoading" @click="shareOnFacebook" class="btn btn-pill btn-primary-solid btn-sm ml-2 share-action-button">
              <i class="fa-brands fa-facebook-f mr-1"></i>
              {{ $t('detail.facebookLabel') }}
            </button>
            <a class="btn btn-primary-solid btn-sm btn-pill ml-2" :href="`mailto:?subject=${$t('detail.emailSubject')}&body=${$t('detail.emailBodyPrefix')} ${ruta}`">
              <i class="fa-solid fa-envelope mr-1"></i> {{ $t('detail.emailButton') }}
            </a>
            <!-- <button @click="modalCompartirCorreo()" class="btn btn-primary btn-sm btn-pill ml-2"><i class="fa-solid fa-envelope mr-1"></i> Correo</button> -->
          </div>

          <div class="d-flex justify-content-end mt-4">
            <button class="btn btn-pill btn-light-secondary" @click="$bvModal.hide('modal-compartir')">{{ $t('detail.closeButton') }}</button>
          </div>
        </div>
      </b-modal>
      <b-modal centered id="modal-compartir-correo" :title="$t('detail.shareModalTitle')" hide-footer class="m-3">
        <div>
          <b-form @submit.prevent="enviarSolicitud">
            <div class="pb-0 mb-0">
              <input required class="form-control" :placeholder="$t('detail.emailPlaceholder')" type="text" v-model="row.Correo" />
            </div>
            <div class="d-flex justify-content-end mt-4">
              <div>
                <button type="submit" class="btn btn-primary btn-pill d-flex justify-content-end">{{ $t('detail.sendButton') }}</button>
              </div>
              <button class="btn btn-pill ml-2 btn-light-secondary" @click="$bvModal.hide('modal-compartir-correo')">{{ $t('detail.closeButton') }}</button>
            </div>
          </b-form>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import {
  buildFacebookPropertyUrl,
  buildPropertyShareVersion,
  buildVersionedShareUrl,
  buildWhatsAppPropertyUrl,
  getShareVersion,
} from "@/utils/propertyUrl";
import { tField } from "@/i18n";

export default {
  props: ["dataPropiedad"],
  mounted() {
    console.log("---line-56", this.dataPropiedad);
  },
  data() {
    return {
      ruta: "",
      shareLoading: false,
      row: { Nombre: "", Celular: "", Mensaje: "", Correo: "" },
    };
  },
  computed: {
    // Locale reactivo para tField
    currentLocale() {
      return this.$i18n.locale;
    },
    itemTitulo() {
      return tField(this.dataPropiedad, "Titulo_Propiedad", this.currentLocale);
    },
    propertyButtons() {
      return [
        { key: "Piscina", label: this.$t("detail.featurePool") },
        { key: "Parqueos", label: this.$t("detail.featureParking") },
        { key: "En_Condominio", label: this.$t("detail.featureGated") },
        { key: "Seguridad_247", label: this.$t("detail.featureSecurity24") },
        { key: "Casa_Club", label: this.$t("detail.featureClubhouse") },
        { key: "Juegos_Infantiles", label: this.$t("detail.featurePlayground") },
        { key: "Gym", label: this.$t("detail.featureGym") },
        { key: "Bodega", label: this.$t("detail.featureStorage") },
        { key: "Cancha_Deportiva", label: this.$t("detail.featureSportsCourt") },
        { key: "Garaje", label: this.$t("detail.featureGarage") },
        { key: "Cuarto_Banio_De_Servicio", label: this.$t("detail.featureServiceRoom") },
      ];
    },
  },
  mounted() {
    this.obtenerRutaActual();
  },
  methods: {
    async enviarSolicitud() {
      try {
        this.obtenerRutaActual();
        console.log(this.agente);
        this.row.propiedad = this.propiedad;

        let data = JSON.parse(JSON.stringify(this.row));
        data.Mensaje = data.Mensaje + " <br> " + this.ruta;
        // let respuesta = await this.$store.dispatch("post", {
        // path: "Agente/envioCorreo/" + this.agente.Email,
        //   data: data,
        // });
        console.log(respuesta);
        this.$swal({
          icon: "success",
          title: this.$t("common.successTitle"),
          text: this.$t("contact.successMessage"),
        });
        this.row.Mensaje = "";
        this.row.Nombre = "";
        this.row.Celular = "";
        this.row.Correo = "";
      } catch (error) {
        console.log("error", error);
      }
    },
    copyToClipboard(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$swal({
            icon: "success",
            title: this.$t("detail.copiedTitle"),
            text: this.$t("detail.copiedText"),
            timer: 1500,
            showConfirmButton: false,
          });
        })
        .catch(() => {
          this.$swal({
            icon: "error",
            title: this.$t("detail.copyErrorTitle"),
            text: this.$t("detail.copyErrorText"),
          });
        });
    },
    obtenerRutaActual(versionar = false) {
      const canonicalUrl = this.$origin + this.$route.path;
      const version = buildPropertyShareVersion(this.dataPropiedad);
      this.ruta = versionar ? buildVersionedShareUrl(canonicalUrl, version) : canonicalUrl;
      console.log("Ruta actual:", this.ruta);
    },
    modalCompartir() {
      this.obtenerRutaActual(true);
      this.$bvModal.show("modal-compartir");
    },
    async prepareSocialPreview() {
      await this.$store.dispatch("post", {
        path: `Configuracion_General/public/prerender/warm/property/${this.dataPropiedad.Id_propiedad}`,
        data: {
          Domain: window.location.hostname,
          share: getShareVersion(this.ruta),
        },
      });
    },
    async shareOnWhatsApp() {
      if (this.shareLoading) return;
      this.shareLoading = true;
      const whatsappWindow = window.open("", "_blank");

      try {
        await this.prepareSocialPreview();
      } catch (error) {
        console.warn("No se pudo precalentar el preview social.", error);
      } finally {
        const whatsappUrl = buildWhatsAppPropertyUrl(this.ruta);
        if (whatsappWindow) {
          whatsappWindow.location.href = whatsappUrl;
        } else {
          window.location.href = whatsappUrl;
        }
        this.shareLoading = false;
      }
    },
    async shareOnFacebook() {
      if (this.shareLoading) return;
      this.shareLoading = true;
      const facebookWindow = window.open("", "_blank");

      try {
        await this.prepareSocialPreview();
      } catch (error) {
        console.warn("No se pudo precalentar el preview social.", error);
      } finally {
        const facebookUrl = buildFacebookPropertyUrl(this.ruta);
        if (facebookWindow) {
          facebookWindow.location.href = facebookUrl;
        } else {
          window.location.href = facebookUrl;
        }
        this.shareLoading = false;
      }
    },
    modalCompartirCorreo() {
      this.$bvModal.show("modal-compartir-correo");
    },
  },
};
</script>

<style scoped>
.share-link-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.share-link-input {
  min-width: 0;
}
.share-copy-button {
  flex: 0 0 auto;
  align-self: center;
  height: calc(1.5em + 0.5rem + 2px) !important;
  margin: 0 !important;
  padding: 0 0.875rem !important;
  line-height: 1.5 !important;
  border-radius: 0.5rem !important;
}
.share-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}
.share-actions .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 !important;
  white-space: nowrap;
}
/* Espaciado adicional para detalles */

/* Agregar margen a los botones */

.text-right {
  text-align: right;
}

/* Para que los detalles no se junten demasiado */
.d-flex.flex-wrap {
  flex-wrap: wrap;
  gap: 15px; /* Espaciado entre los detalles */
}
p {
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
}
.w-div-precio {
  margin-left: auto !important;
  text-align: right;
  width: 30%;
}
.w-div-botones-filtro {
  width: 60%;
  margin-left: auto !important;
  text-align: right;
}
@media (max-width: 576px) {
  .share-link-row {
    flex-direction: column;
  }
  .share-copy-button,
  .share-actions .btn {
    width: 100%;
  }
  /* Estilos para pantallas pequeñas */
  .w-div-botones-filtro {
    width: 100%;
    /* margin-left: auto !important; */
    text-align: left;
  }
  .w-div-precio {
    width: 100%;

    text-align: left;
  }
}
</style>
